import Api from "@/config/Api";

/**
 * Requisitos de la firma electrónica comprada (adicional de firma o plan con
 * firma). El backend dice qué compras aún no tienen documentos y guarda los
 * archivos en un disco privado que solo ve el equipo de Mydessk.
 */
export const SIGNATURE_MAX_MB = 5;

export const SIGNATURE_STATUS_LABEL = {
  pending: "Recibida, pendiente de revisión",
  in_review: "En revisión",
  approved: "Aprobada",
  rejected: "Rechazada"
};

/** Compras que todavía piden documentos: sin enviar, o rechazadas para reenviar. */
export function signaturesToComplete(overview) {
  const o = overview || { pending: [], requests: [] };
  return [
    ...(o.pending || []).map(p => ({ ...p, rejected: undefined })),
    ...(o.requests || [])
      .filter(r => r.status === "rejected")
      .map(r => ({ source_type: r.source_type, source_id: r.source_id, label: r.label, rejected: r.admin_notes }))
  ];
}

/**
 * Reduce fotos pesadas (lado mayor 2000 px, JPEG 85 %) para que el envío
 * completo quepa en el límite del servidor. PDFs o fotos livianas van tal cual.
 */
export async function compressImage(file, maxSide = 2000, quality = 0.85) {
  if (!/\.(jpe?g|png|webp|heic)$/i.test(file.name) || file.size <= 1024 * 1024) return file;
  try {
    const bmp = await createImageBitmap(file);
    const scale = Math.min(1, maxSide / Math.max(bmp.width, bmp.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bmp.width * scale);
    canvas.height = Math.round(bmp.height * scale);
    canvas.getContext("2d").drawImage(bmp, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise(res => canvas.toBlob(res, "image/jpeg", quality));
    if (!blob || blob.size >= file.size) return file;
    return new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg" });
  } catch (e) {
    return file;
  }
}

export default {
  getOverview() {
    return Api().get("/signature-requests");
  },
  async submit({ sourceType, sourceId, personType, docs }) {
    const fd = new FormData();
    fd.append("source_type", sourceType);
    fd.append("source_id", String(sourceId));
    fd.append("person_type", personType);
    fd.append("ruc", docs.ruc[0]);
    for (const f of docs.id_card) fd.append("id_card[]", await compressImage(f));
    fd.append("selfie", await compressImage(docs.selfie[0]));
    if (personType === "company") {
      fd.append("constitution", docs.constitution[0]);
      fd.append("appointment", docs.appointment[0]);
    }
    return Api().post("/signature-requests", fd);
  }
};
